import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-signup-complete',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './registration-submitted.component.html',
  styleUrls: ['./registration-submitted.component.scss']
})
export class RegistrationSubmittedComponent {
  constructor(private router: Router) {}

  goToSignin(): void {
    this.router.navigate(['/signin']);
  }
}
